import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
const IconSizes = {
    xs: "s-h-4 s-w-4",
    sm: "s-h-5 s-w-5",
    md: "s-h-6 s-w-6",
    lg: "s-h-8 s-w-8",
    xl: "s-h-12 s-w-12",
    "2xl": "s-h-20 s-w-20",
};
export function Icon({ visual: IconComponent, size = "sm", className = "", }) {
    return IconComponent ? (React.createElement(IconComponent, { className: cn(className, "s-shrink-0", IconSizes[size]) })) : null;
}
const sizeVariants = cva("s-relative", {
    variants: {
        size: {
            sm: "s-h-5 s-w-5",
            md: "s-h-6 s-w-6",
            lg: "s-h-8 s-w-8 s-p-0.5",
            xl: "s-h-10 s-w-10",
        },
    },
    defaultVariants: {
        size: "lg",
    },
});
const iconSizeVariants = cva("s-absolute", {
    variants: {
        size: {
            sm: "s-bottom-0 s-right-0",
            md: "s-bottom-0 s-right-0",
            lg: "s-bottom-0 s-right-0",
            xl: "s-bottom-0 s-right-0",
        },
    },
    defaultVariants: {
        size: "lg",
    },
});
export const DoubleIcon = ({ mainIcon, secondaryIcon, className, size = "lg", }) => {
    return (React.createElement("div", { className: cn(sizeVariants({ size }), className) },
        React.createElement(Icon, { className: "s-text-foreground dark:s-text-foreground-night", size: size === "sm"
                ? "xs"
                : size === "md"
                    ? "sm"
                    : size === "lg"
                        ? "md"
                        : "lg", visual: mainIcon }),
        React.createElement(Icon, { size: size === "sm"
                ? "xs"
                : size === "md"
                    ? "xs"
                    : size === "lg"
                        ? "xs"
                        : "md", visual: secondaryIcon, className: cn("s-absolute", iconSizeVariants({ size })) })));
};
//# sourceMappingURL=Icon.js.map